export { default } from './VacanciesSection';
export * from './VacanciesSection.style';
